import React, { useState } from "react";
import { Popover } from "@mui/material";
import { FilterAltOutlined, FilterAltRounded } from "@mui/icons-material";

/**
 * A table header you can search from: the label plus a funnel, and a click opens a
 * small popover holding the column's filter (a text box, a server-searched picker, or
 * anything else passed as children). `active` fills and tints the funnel, so a
 * filtered column is visible without opening it.
 *
 * children may be a function — `(close) => …` — for a filter that closes on pick.
 */
const HeaderFilter = ({ label, active = false, children, width = 260, align = "left" }) => {
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);
  const Icon = active ? FilterAltRounded : FilterAltOutlined;

  return (
    <>
      <button
        type="button"
        onClick={(e) => setAnchor(e.currentTarget)}
        className={`inline-flex items-center gap-1 max-w-full uppercase tracking-wide font-semibold text-[11px] hover:text-primary ${
          active ? "text-primary" : ""
        }`}
      >
        <span className="truncate">{label}</span>
        <Icon sx={{ fontSize: 14, opacity: active ? 1 : 0.55 }} />
      </button>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: align }}
        transformOrigin={{ vertical: "top", horizontal: align }}
        PaperProps={{ sx: { p: 0.75, width, maxWidth: "calc(100vw - 32px)", borderRadius: "10px" } }}
      >
        {typeof children === "function" ? children(close) : children}
      </Popover>
    </>
  );
};

export default HeaderFilter;
